import { Link } from 'react-router-dom';
import { categories } from '@/mocks/novels';
import { siteInfo } from '@/mocks/novels';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-3-line text-xl text-primary-400"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50 tracking-wide">
                  都市美艳后宫
                </span>
              </Link>
              <p className="text-sm text-background-300 leading-relaxed mt-3">
                {siteInfo.tagline}
              </p>
              <div className="flex items-center gap-4 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                分类导航
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                热门推荐
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/article/12" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    都市之最强王者
                  </Link>
                </li>
                <li>
                  <Link to="/article/4" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    战神归来之都市风云
                  </Link>
                </li>
                <li>
                  <Link to="/article/1" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    都市最强赘婿
                  </Link>
                </li>
                <li>
                  <Link to="/article/8" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    极品太子爷
                  </Link>
                </li>
                <li>
                  <Link to="/article/3" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    总裁的绝色娇妻
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                关于我们
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    隐私政策
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    版权声明
                  </a>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    联系我们
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {currentYear} 都市美艳后宫. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <span className="text-xs text-background-400">
                收录 {siteInfo.totalNovels.toLocaleString()} 部小说
              </span>
              <span className="text-xs text-background-400">
                {siteInfo.totalReaders.toLocaleString()} 位读者
              </span>
              <span className="text-xs text-background-400">
                {siteInfo.totalWords.toLocaleString()} 字内容
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}